import { getAccessToken, getUserId } from '@/utils/auth-token';
import { getAuthGeneration } from '@/utils/auth-teardown';

/** Carry the initiating session through nested async work and before every mutation. */
export function captureAuthOperationGuard() {
  const token = getAccessToken();
  const userId = String(getUserId() ?? '');
  const generation = getAuthGeneration();
  return () => {
    if (
      getAccessToken() !== token ||
      String(getUserId() ?? '') !== userId ||
      getAuthGeneration() !== generation
    ) {
      const err = new Error('AUTH_SESSION_CHANGED');
      err.code = 'AUTH_SESSION_CHANGED';
      err.name = 'AbortError';
      throw err;
    }
  };
}
